import { memo, useEffect, useState } from 'react'

import { ReactComponent as EmptyImage } from 'assets/images/svg/topics/empty-niche.svg'
import { useTranslate } from 'lib/tolgee'

import { translations } from './niche-charts-tab.i18n'
import type { INicheChartsTabEmpty } from './niche-charts-tab.types'

const NicheChartsTabEmpty = ({ contextId }: INicheChartsTabEmpty) => {
  const [showLoading, setShowLoading] = useState(false)
  const t = useTranslate()

  useEffect(() => {
    window.setTimeout(() => setShowLoading(true), 2000)
    setShowLoading(false)
  }, [contextId])

  if (!showLoading) {
    return null
  }

  return (
    <div className="NicheChartsTab-emptyState">
      <EmptyImage height="258px" width="274px" />
      <div className="emptyText">
        <p>{t(translations.emptyStateTitle)}</p>
        <span>{t(translations.emptyStateDescription)}</span>
      </div>
    </div>
  )
}

export default memo(NicheChartsTabEmpty)
